export default "__VITE_ASSET__d5a61dbe__"